(function(document) {

    sessionStorage.setItem("countryClaim", "") // Step1 country
    sessionStorage.setItem("isCovered", "") // Step2 covered

    sessionStorage.setItem("involvedParts", "") // List of involved parts
    sessionStorage.setItem("requestType", "Warranty Claim") // "Warranty Claim" or "Part Request", default "Warranty Claim"

    sessionStorage.setItem("purchasedYear", "") // Binding purchase year

    var selectors = {
        pageTitle: '.page-new-warranty-claim h1',
        claimStep1: '.claim-step[attr_step="1"]',
        claimStep2: '.claim-step[attr_step="2"]',
        claimStep3:  '.claim-step[attr_step="3"]',
        claimStep4:  '.claim-step[attr_step="4"]',
        claimStepFormProcess1:  '.claim-step[attr_step="covered-1"]',
        claimStepFormProcess2:  '.claim-step[attr_step="covered-2"]',
        claimStepFormRecap:  '.claim-step[attr_step="recap"]',
        claimStepPartRequest: '.claim-step[attr_step="part-request"]', 
        goto_step3: '.union-general-button--step-3',
        claimStep1_country: '.claim-step__country',
        claimResult_distribution: '.section-result-distributor',
        claimResult_distributionContent: '.section-result-distributor__content',
        select_covered: '.claim-step__covered',
        covered: '.covered-step__single',
        componentPartImages: '.part-image',
        componentListPins: '.component-list .spec_pin',
        componentPartsImagePins: ".involved-parts__binding-parts__image .spec_pin",
        componentsPartsBtns: ".involved-parts__binding-parts__select__btn",
        componentsPartsImages: ".involved-parts__binding-parts__image",
        componentsPartsLists: ".involved-parts__components-list",
        yearPurchaseSelect: ".claim-step__purchased",
        yearPurchaseOption: ".purchased-step__single",
        stepSelectFormCountries: ".step-form-country",
        stepSelectFormModels: ".step-form-info__model",
        stepSelectFormDirections: ".step-form-info__direction",
        stepSelectFormSizes: ".step-form-info__size",
        stepFormModels: ".step-form-info__model__single",
        stepFormDirections: ".step-form-info__direction__single",
        stepFormSizes: ".step-form-info__size__single",
        stepFormMessage: ".step-form-message textarea",
        stepFormContacts: ".step-form-contact",
        stepFormShips: ".step-form-ship",
        recapParts: ".claim-recap-parts",
        recapBindingModel: ".claim-recap-binding",
        recapShip: ".claim-recap-ship",
        recapInfos: ".claim-recap-infos",
        claimWarranty: ".claim-warranty",
        claimPre: '.claim-pre',
        claimAfter: '.claim-after',
        claimSteps : '.claim-step',
        errorAfter: '.error-after',
        claimSubmit: '.claim-submit',
        claimSubmitBtn: '.claim-submit .union-general-button',
        claimSubmitPrivacy: '.claim-recap-privacy input[name="privacy"]',
        infoImage__b: '#binding',
        infoImage__p: '#part',
        country_pre_compiled: '.country-pre-compiled input'
    };

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var stepUrl = urlParams.get('step')

    var actualYear = new Date().getFullYear()
    var coveredYear = actualYear - 2

    var localDomain = window.location.hostname

    var involvedPartsList = ""

    var pageTitle = document.querySelector(selectors.pageTitle);
    var claimStep1 = document.querySelector(selectors.claimStep1);
    var claimStep2 = document.querySelector(selectors.claimStep2);
    var claimStep3 = document.querySelector(selectors.claimStep3);
    var claimStep4 = document.querySelector(selectors.claimStep4);
    var claimStepFormProcess1 = document.querySelector(selectors.claimStepFormProcess1);
    var claimStepFormProcess2 = document.querySelector(selectors.claimStepFormProcess2);
    var claimStepFormRecap = document.querySelector(selectors.claimStepFormRecap);
    var claimStepPartRequest = document.querySelector(selectors.claimStepPartRequest);
    var checkPartInsert = false
    var claimStep1_country = document.querySelector(selectors.claimStep1_country);
    var countries = ""
    var goto_step3 = document.querySelector(selectors.goto_step3);
    var claimResult_distribution = document.querySelector(selectors.claimResult_distribution);
    var claimResult_distributionContent = document.querySelector(selectors.claimResult_distributionContent);
    var select_covered = document.querySelector(selectors.select_covered);
    var covered = document.querySelectorAll(selectors.covered);
    var componentPartImages = document.querySelectorAll(selectors.componentPartImages);
    var componentListPins = document.querySelectorAll(selectors.componentListPins);
    var componentPartsImagePins = document.querySelectorAll(selectors.componentPartsImagePins);
    var componentsPartsBtns = document.querySelectorAll(selectors.componentsPartsBtns);
    var componentsPartsImages = document.querySelectorAll(selectors.componentsPartsImages);
    var componentsPartsLists = document.querySelectorAll(selectors.componentsPartsLists);
    var yearPurchaseSelect = document.querySelector(selectors.yearPurchaseSelect);
    var yearPurchaseOption = document.querySelectorAll(selectors.yearPurchaseOption);
    var stepSelectFormCountries = document.querySelector(selectors.stepSelectFormCountries);
    var stepSelectFormModels = document.querySelector(selectors.stepSelectFormModels);
    var stepSelectFormDirections = document.querySelector(selectors.stepSelectFormDirections);
    var stepSelectFormSizes = document.querySelector(selectors.stepSelectFormSizes);
    var stepFormModels = document.querySelectorAll(selectors.stepFormModels);
    var stepFormDirections = document.querySelectorAll(selectors.stepFormDirections);
    var stepFormSizes = document.querySelectorAll(selectors.stepFormSizes);
    var stepFormMessage = document.querySelector(selectors.stepFormMessage);
    var recapParts = document.querySelector(selectors.recapParts);
    var recapBindingModel = document.querySelector(selectors.recapBindingModel);
    var recapModel = recapBindingModel.querySelector(".claim-recap-binding__model")
    var recapYear = recapBindingModel.querySelector(".claim-recap-binding__year")
    var recapDirection = recapBindingModel.querySelector(".claim-recap-binding__direction")
    var recapSize = recapBindingModel.querySelector(".claim-recap-binding__size")
    var recapMessage = recapBindingModel.querySelector(".claim-recap-binding__how")
    var recapInfos = document.querySelector(selectors.recapInfos)
    var recapInfosFirstName = recapInfos.querySelector(".claim-recap-info__firstname")
    var recapInfosLastName = recapInfos.querySelector(".claim-recap-info__lastname")
    var recapInfosEmail = recapInfos.querySelector(".claim-recap-info__email")
    var recapInfosPhone = recapInfos.querySelector(".claim-recap-info__phone")
    var recapShip = document.querySelector(selectors.recapShip);
    var recapShipAddr1 = recapShip.querySelector(".claim-recap-ship__addr1")
    var recapShipAddr2 = recapShip.querySelector(".claim-recap-ship__addr2")
    var recapShipCity = recapShip.querySelector(".claim-recap-ship__city")
    var recapShipState = recapShip.querySelector(".claim-recap-ship__state")
    var recapShipZip = recapShip.querySelector(".claim-recap-ship__zip")
    var recapShipCountry = recapShip.querySelector(".claim-recap-ship__country")
    var stepFormContacts = document.querySelector(selectors.stepFormContacts)
    var stepFormContacts_imageB = document.querySelector(".file-upload input[name='binding']")
    var stepFormContacts_imageP = document.querySelector(".file-upload input[name='part']")
    var stepFormContacts_firstname = stepFormContacts.querySelector(".input-contact input[name='firstname']")
    var stepFormContacts_lastname = stepFormContacts.querySelector(".input-contact input[name='lastname']")
    var stepFormContacts_email = stepFormContacts.querySelector(".input-contact input[name='email']")
    var stepFormContacts_phone = stepFormContacts.querySelector(".input-contact input[name='phone']")
    var stepFormShips = document.querySelector(selectors.stepFormShips)
    var stepFormShips_address1 = stepFormShips.querySelector(".input-contact input[name='address1']")
    var stepFormShips_address2 = stepFormShips.querySelector(".input-contact input[name='address2']")
    var stepFormShips_city = stepFormShips.querySelector(".input-contact input[name='city']")
    var stepFormShips_state = stepFormShips.querySelector(".input-contact input[name='stateclaim']")
    var stepFormShips_zip = stepFormShips.querySelector(".input-contact input[name='zip']")
    var stepFormShips_country = stepFormShips.querySelector(".input-contact input[name='country']")
    var claimWarranty = document.querySelector(selectors.claimWarranty);
    var claimPre = document.querySelector(selectors.claimPre);
    var claimAfter = document.querySelector(selectors.claimAfter);
    var claimSteps = document.querySelectorAll(selectors.claimSteps);
    var errorAfter = document.querySelector(selectors.errorAfter);
    var claimSubmit = document.querySelector(selectors.claimSubmit);
    var claimSubmitBtn = document.querySelector(selectors.claimSubmitBtn);
    var claimSubmitPrivacy = document.querySelector(selectors.claimSubmitPrivacy);
    var infoImage__b = document.querySelector(selectors.infoImage__b);
    var infoImage__p = document.querySelector(selectors.infoImage__p);
    var country_pre_compiled = document.querySelector(selectors.country_pre_compiled);
    var async_country_step = function () {

        country_selected = this.textContent
        country_pre_compiled.value = country_selected
        recapShipCountry.innerHTML = country_selected
        region_selected = this.getAttribute("attr-region")
        state_selected = this.getAttribute("attr-filter")

        claimStep1_country.insertAdjacentElement('afterbegin', this);
        // claimStep1_country.classList.remove("open")
        // claimStep1_country.querySelector(".fa-chevron-down").classList.remove("open")
        if (claimStep1_country.querySelector(".select-style__single--select")) {
            claimStep1_country.querySelector(".select-style__single--select").remove()
        }

        if  (
                (region_selected == "NA") || 
                (region_selected == "EU") || 
                (region_selected == "JP") || 
                (region_selected == "AUS") || 
                (region_selected == "NZL")
            ) {

                switch (true) {
                    case localDomain == "unionbindingcompany.com":
                        if (region_selected == "NA") {
                            sessionStorage.setItem("countryClaim", state_selected)
                            unlock_next()
                        } else {
                            redirect_country(region_selected)
                        }
                    break;

                    case localDomain == "eu.unionbindingcompany.com":
                        if (region_selected == "EU") {
                            sessionStorage.setItem("countryClaim", state_selected)
                            unlock_next()
                        } else {
                            redirect_country(region_selected)
                        }
                    break;
                    
                    case localDomain == "aus.unionbindingcompany.com":
                        if (region_selected == "AUS") {
                            sessionStorage.setItem("countryClaim", state_selected)
                            unlock_next()
                        } else {
                            redirect_country(region_selected)
                        }
                    break;
                    case localDomain == "nz.unionbindingcompany.com":
                        if (region_selected == "NZL") {
                            sessionStorage.setItem("countryClaim", state_selected)
                            unlock_next()
                        } else {
                            redirect_country(region_selected)
                        }
                    break;
                }

        } else {
            jQuery.ajax({
                url:"https://eu.unionbindingcompany.com/pages/finder-list?view=country-metafields.json", 
                success:function(countries_async) {
    
                    var countries_parse = JSON.parse(countries_async)
    
                    for (var region_single of Object.keys(countries_parse)) {
    
                        countries_parse[region_single].forEach((country_single,cs) => { 
                        
                            for (var country_name of Object.keys(country_single)) {
                                
                                var info_distributor = ""
                                var distr_address = ""
                                var distr_phone = ""
                                var distr_fax = ""
                                var distr_email_secon = ""
                                var distr_email = ""
                                var distr_website = ""
                                
                                if (country_name == country_selected) {
                                
                                    if (country_single[country_name][1]) {
                                        distr_address = `
                                            <div class="distributor-info__content__row">
                                                <div class="distributor-info__content__col-title">ADDRESS</div>
                                                <div class="distributor-info__content__col-data">`+country_single[country_name][1]+`</div>
                                            </div>`
                                    }
                                    if (country_single[country_name][2]) {
                                        distr_phone = `
                                            <div class="distributor-info__content__row">
                                                <div class="distributor-info__content__col-title">PHONE</div>
                                                <div class="distributor-info__content__col-data">`+country_single[country_name][2]+`</div>
                                            </div>`
                                    }
                                    if (country_single[country_name][3]) {
                                        distr_fax =  `
                                            <div class="distributor-info__content__row">
                                                <div class="distributor-info__content__col-title">FAX</div>
                                                <div class="distributor-info__content__col-data">`+country_single[country_name][3]+`</div>
                                            </div>`
                                    }
                                    if (country_single[country_name][7]) {
                                        distr_email =  `
                                            <div class="distributor-info__content__row">
                                                <div class="distributor-info__content__col-title">EMAIL WARRANTY</div>
                                                <div class="distributor-info__content__col-data"><a href="mailto:`+country_single[country_name][7]+`">`+country_single[country_name][7]+`</a></div>
                                            </div>`
                                    } else {
                                        // check secondary email
                                        if (country_single[country_name][5]) {
                                            distr_email_secon =  `
                                             - <a href="mailto:`+country_single[country_name][5]+`">`+country_single[country_name][5]+`</a>`
                                        }
                                        // check email
                                        if (country_single[country_name][4]) {
                                            distr_email =  `
                                                <div class="distributor-info__content__row">
                                                    <div class="distributor-info__content__col-title">EMAIL</div>
                                                    <div class="distributor-info__content__col-data"><a href="mailto:`+country_single[country_name][4]+`">`+country_single[country_name][4]+`</a>
                                                    `+distr_email_secon+`</div>
                                                </div>`
                                        }
                                    }
    
                                    if (country_single[country_name][6]) {
                                        distr_website =  `
                                            <div class="distributor-info__content__row">
                                                <div class="distributor-info__content__col-title">WEBSITE</div>
                                                <div class="distributor-info__content__col-data"><a href="`+country_single[country_name][6]+`" target="_blank">`+country_single[country_name][6]+`</a></div>
                                            </div>`
                                    }
    
                                    info_distributor = `
                                        <div class="distributor-info">
                                            <div class="distributor-info__title">
                                            <h3>`+country_name+`</h3>
                                            <h5>`+country_single[country_name][0]+`</h5>
                                            </div>
                                            <div class="distributor-info__content">
                                            `+distr_address+`
                                            `+distr_phone+`
                                            `+distr_fax+`
                                            `+distr_email+`
                                            `+distr_website+`
                                            </div>
                                        </div>
                                    `
                                    claimResult_distributionContent.insertAdjacentHTML('beforeend', info_distributor);
                                    claimResult_distribution.classList.remove("hide")
                                    claimStep1.classList.remove("active")
                                    check_navigation("pre",null,"show",null,1,null)
                                }
                            }
                        })
                    }
                }
            })
        }
    }

    // START - FUNCTIONS

        function check_navigation(pre,after,pre_change,after_change,pre_step,after_step) {
            if (pre) {
                pre_change == "hidden" ? claimPre.classList.add("hidden") : claimPre.classList.remove("hidden")
                if (pre_step == "warranty-page") {
                    claimPre.querySelector(".union-general-button").setAttribute("href", "/pages/new-warranty")
                } else {
                    claimPre.querySelector(".union-general-button").removeAttribute("href")
                    claimPre.setAttribute("attr_gotostep", pre_step)
                }
            }
            if (after) {
                after_change == "hidden" ? claimAfter.classList.add("hidden") : claimAfter.classList.remove("hidden")
                after_change == "hide" ? claimAfter.classList.add("hide") : claimAfter.classList.remove("hide")
                claimAfter.setAttribute("attr_gotostep", after_step)
            }

            if (claimStep3.classList.contains("active")) {
                if (sessionStorage.getItem("involvedParts").length > 0) {
                    unlock_next()
                } else {
                    block_next()
                }
            }

        }

        function check_step() {
            if (claimStep1.classList.contains("active")) {
                block_next()
                claimWarranty.classList.remove("hide")
                claimPre.classList.add("hide")
                countries = " "
                countries = claimStep1_country.querySelectorAll(".country-step__single")
                step1()
                check_navigation("pre","after","","","","2")
                claimResult_distributionContent.innerHTML = ""
                claimResult_distribution.classList.add("hide")
                pageTitle.innerHTML = sessionStorage.getItem("requestType")
            }

            if (claimStep2.classList.contains("active")) {
                block_next()
                claimWarranty.classList.add("hide")
                claimPre.classList.remove("hide")
                check_navigation("pre","after","show","show","1","3")
                step2()
                pageTitle.innerHTML = sessionStorage.getItem("requestType")
            }
            // step involved parts
            if (claimStep3.classList.contains("active")) {
                check_navigation("pre","after","show","show","2","4")
                claimWarranty.classList.add("hide")
                claimPre.classList.remove("hide")
                pageTitle.innerHTML = sessionStorage.getItem("requestType")
            }
            if (claimStep4.classList.contains("active")) {
                check_navigation("pre","after","show","show","3","")
                block_next()
            }
            if (claimStepFormProcess1.classList.contains("active")) {
                check_navigation("pre","after","show","show","4","covered-2")
                block_next()
                let file_binding = document.querySelector("#binding")
                let file_part = document.querySelector("#part")
                if (file_binding) {
                    file_binding.onchange = function() {
                        console.log(this.files[0].size)
                        if(this.files[0].size > 20097152) {
                           alert("File is too big!");
                           this.value = "";
                        }
                    };
                }
                if (file_part) {
                    file_part.onchange = function() {
                        console.log(this.files[0].size)
                        if(this.files[0].size > 20097152) {
                           alert("File is too big!");
                           this.value = "";
                        }
                    };
                }
            }
            if (claimStepFormProcess2.classList.contains("active")) {
                check_navigation("pre","after","show","show","covered-1","recap")
                claimSubmit.classList.add("hide")
                block_next()
            }
            if (claimStepFormRecap.classList.contains("active")) {
                check_navigation("pre","after","show","hide","covered-2","")
                claimSubmit.classList.remove("hide")
            }
            if (claimStepPartRequest.classList.contains("active")) {
                check_navigation("pre","after","show","hidden","1","")
                pageTitle.innerHTML = "Not Covered By Warranty"
            }
        }

        // function step_part_request() {
        //     claimStep2.classList.remove("active")
        //     claimStep4.classList.remove("active")
        //     claimStepPartRequest.classList.add("active")
        //     check_navigation("pre","after","show","hidden","2","")
        // }

        function step1() {
            if (countries) {
                countries.forEach(function(country){
                    if (!country.classList.contains("select-style__single--select")) {
                        country.addEventListener("click", async_country_step, false )
                    }
                })
            }
        }

        function step2() {
            claimStep1.classList.remove("active")
            claimStep2.classList.add("active")
            select_covered_arrow = select_covered.querySelector(".fa-chevron-down")
            covered.forEach(function(cover) {
                var attr_cover = cover.getAttribute("attr-covered")
                cover.addEventListener("click", function() {
                    // select_covered.classList.remove("open")
                    // select_covered_arrow.classList.remove("open")
                    select_covered.insertAdjacentElement('afterbegin', this);
                    if (select_covered.querySelector(".select-style__single--select")) {
                        select_covered.querySelector(".select-style__single--select").remove()
                    }

                    if (attr_cover == "yes") {
                        check_navigation("pre","after","show","show","1","3")
                        sessionStorage.setItem("requestType", "Warranty Claim")
                        pageTitle.innerHTML = sessionStorage.getItem("requestType")
                    } else {
                        check_navigation("pre","after","show","show","1","part-request")
                        sessionStorage.setItem("requestType", "Part Request")
                        pageTitle.innerHTML = sessionStorage.getItem("requestType")
                    }
                    sessionStorage.setItem("isCovered", attr_cover)
                    unlock_next()
                }, false )
            })
        }

        function step3() {
            claimStep2.classList.remove("active")
            claimStepPartRequest.classList.remove("active")
            claimStep3.classList.add("active")
            check_navigation("pre","after","show","show","2","4")
        }

        function step4() {
            block_next()
            claimStep3.classList.remove("active")
            claimStep4.classList.add("active")
            check_navigation("pre","after","show","show","","")
        }

        function stepFormProcess1() {
            claimStep3.classList.remove("active")
            claimStep4.classList.remove("active")
            claimStepPartRequest.classList.remove("active")
            claimStepFormProcess1.classList.add("active")
            var preLink = "4" // to step 4 'purchase year'
            if (sessionStorage.getItem("requestType") == "Part Request") {
                preLink = "part-request"
            }
            check_navigation("pre","after","show","show",preLink,"covered-2")
            block_next()
        }

        // function createRequestPartList() {
            
        //     involvedPartsList = ""

        //     componentListPins.forEach(function(componentPinSingle){
        //         if (componentPinSingle.classList.contains("selected")) {
        //             var componentPinSingle_attrSpec = componentPinSingle.getAttribute("attr-spec")
        //             if (involvedPartsList.length > 0) {
        //                 involvedPartsList = involvedPartsList.concat(", ", componentPinSingle_attrSpec)
        //             } else {
        //                 involvedPartsList = involvedPartsList.concat(componentPinSingle_attrSpec)
        //             }
        //         }
        //     })
        //     sessionStorage.setItem("involvedParts", involvedPartsList)
        //     recapParts.innerHTML = involvedPartsList
        //     // console.log(sessionStorage.getItem("involvedParts"))
        // }

        function block_next() {
            claimAfter.classList.add("inactive")
        }

        function unlock_next() {
            claimAfter.classList.remove("inactive")
        }

        function cleanPartSelected() {
            sessionStorage.setItem("involvedParts", "")
            componentListPins.forEach(function(componentPin_clean){
                componentPin_clean.classList.remove("selected")
            })
            componentPartsImagePins.forEach(function(componentImagePin_clean){
                componentImagePin_clean.classList.remove("selected")
            })
            componentPartImages.forEach(function(partImage_clean){ 
                partImage_clean.classList.remove("selected")
            })
            block_next()
        }

        function checkSelectionParts() {
            checkPartInsert = false
            involvedPartsList = ""
            var componentPinSingle_attrSpec = ""
            componentListPins.forEach(function(componentPin_check){
                if (componentPin_check.classList.contains("selected")) {
                    checkPartInsert = true

                    componentPinSingle_attrSpec = componentPin_check.getAttribute("attr-spec")
                    if (involvedPartsList.length > 0) {
                        involvedPartsList = involvedPartsList.concat(", ", componentPinSingle_attrSpec)
                    } else {
                        involvedPartsList = involvedPartsList.concat(componentPinSingle_attrSpec)
                    }

                } 
                
                sessionStorage.setItem("involvedParts", involvedPartsList)
                recapParts.innerHTML = involvedPartsList

                if (checkPartInsert) {
                    unlock_next()
                } else {
                    block_next()
                }
            })
        }

        function checkDataCompileStep1() {
            if  (
                (recapModel.innerHTML.length != 0) &&
                (recapDirection.innerHTML.length != 0) &&
                (recapSize.innerHTML.length != 0) &&
                (stepFormContacts_imageB.files[0]) &&
                (stepFormContacts_imageP.files[0])
                ) {
                    unlock_next()
                } else {
                    block_next()
                }
        }

        function checkDataCompileStep2() {
            if (recapInfosFirstName.innerHTML.length != 0) {
                document.querySelector(".step-form-contact .input-contact input[name='firstname']").classList.add("compiled")
            } else {
                document.querySelector(".step-form-contact .input-contact input[name='firstname']").classList.remove("compiled")
            }
            if (recapInfosLastName.innerHTML.length != 0) {
                document.querySelector(".step-form-contact .input-contact input[name='lastname']").classList.add("compiled")
            } else {
                document.querySelector(".step-form-contact .input-contact input[name='lastname']").classList.remove("compiled")
            }
            if (recapInfosEmail.innerHTML.length != 0) {
                document.querySelector(".step-form-contact .input-contact input[name='email']").classList.add("compiled")
            } else {
                document.querySelector(".step-form-contact .input-contact input[name='email']").classList.remove("compiled")
            }
            if (recapInfosPhone.innerHTML.length != 0) {
                document.querySelector(".step-form-contact .input-contact input[name='phone']").classList.add("compiled")
            } else {
                document.querySelector(".step-form-contact .input-contact input[name='phone']").classList.remove("compiled")
            }
            if (recapShipAddr1.innerHTML.length != 0) {
                document.querySelector(".step-form-ship .input-contact input[name='address1']").classList.add("compiled")
            } else {
                document.querySelector(".step-form-ship .input-contact input[name='address1']").classList.remove("compiled")
            }
            if (recapShipCity.innerHTML.length != 0) {
                document.querySelector(".step-form-ship .input-contact input[name='city']").classList.add("compiled")
            } else {
                document.querySelector(".step-form-ship .input-contact input[name='city']").classList.remove("compiled")
            }
            if (recapShipState.innerHTML.length != 0) {
                document.querySelector(".step-form-ship .input-contact input[name='stateclaim']").classList.add("compiled")
            } else {
                document.querySelector(".step-form-ship .input-contact input[name='stateclaim']").classList.remove("compiled")
            }
            if (recapShipZip.innerHTML.length != 0) {
                document.querySelector(".step-form-ship .input-contact input[name='zip']").classList.add("compiled")
            } else {
                document.querySelector(".step-form-ship .input-contact input[name='zip']").classList.remove("compiled")
            }
            if  (
                (recapInfosFirstName.innerHTML.length != 0) &&
                (recapInfosLastName.innerHTML.length != 0) &&
                (recapInfosEmail.innerHTML.length != 0) &&
                (recapInfosPhone.innerHTML.length != 0) &&
                (recapShipAddr1.innerHTML.length != 0) &&
                (recapShipCity.innerHTML.length != 0) &&
                (recapShipState.innerHTML.length != 0) &&
                (recapShipZip.innerHTML.length != 0) 
                ) {
                    unlock_next()
                } else {
                    block_next()
                }
        }

        function scrollTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        function goToStepPartRequest() {
            sessionStorage.setItem("requestType", "Part Request")
            pageTitle.innerHTML = sessionStorage.getItem("requestType")
            claimStep1.classList.add("active")
            claimStep2.classList.remove("active")
            claimStepPartRequest.classList.remove("active")
            check_navigation("pre","after","show","show","1","3")
            // step3()
        }

    // END - FUNCTIONS


    // START - FIRST CONTROLS

    check_step()
    
    if (stepUrl === 'part-request') {
        goToStepPartRequest()
    }

    // END - FIRST CONTROLS


    // START - PART REQUEST

    goto_step3.addEventListener("click", function() {
        sessionStorage.setItem("requestType", "Part Request")
        pageTitle.innerHTML = sessionStorage.getItem("requestType")
        if (sessionStorage.getItem("involvedParts").length > 0) {
            stepFormProcess1()
        } else {
            step3()
        }
    }, false )

    // END - PART REQUEST


    // INVOLVED PARTS - START

    // BTN COMPONENTS TYPE
    componentsPartsBtns.forEach(function(componentBtn){
        componentBtn.addEventListener("click", function() {

            componentsPartsBtns.forEach(function(componentBtn_reset){  
                componentBtn_reset.classList.add("unselected")
            })
            this.classList.remove("unselected")

            cleanPartSelected() 

            var componentBtnType = this.getAttribute("attr-binding-type")

            componentsPartsImages.forEach(function(componentsPartsImage){
                var compType = componentsPartsImage.getAttribute("attr-binding-type")
                componentBtnType == compType ? componentsPartsImage.classList.remove("hide") : componentsPartsImage.classList.add("hide")
            })
            componentsPartsLists.forEach(function(componentsPartsList){
                var compType = componentsPartsList.getAttribute("attr-binding-type")
                componentBtnType == compType ? componentsPartsList.classList.remove("hide") : componentsPartsList.classList.add("hide")
            })

            // filter models inside "select model"
            stepFormModels.forEach(function(stepFormModel){
                var bindType = stepFormModel.getAttribute("attr-type")
                if (!stepFormModel.classList.contains('select-style__single--select')) {
                    componentBtnType == bindType ? stepFormModel.classList.remove("hide") : stepFormModel.classList.add("hide")
                    bindType == "step-on" ? stepFormModel.click() : null
                } else {
                    stepFormModel.classList.remove("hide")
                }
            })


        }, false )
    })

    // PIN LIST
    componentListPins.forEach(function(componentPin){
        componentPin.addEventListener("click", function() {

            var pinPart = this.getAttribute("attr-spec")
            var pinPart_type = this.getAttribute("attr-binding-type")

            if (this.classList.contains("selected")) {
                this.classList.remove("selected")
            } else {
                this.classList.add("selected")
            } 

            // createRequestPartList()

            componentPartsImagePins.forEach(function(componentImagePin){
                
                var pinImagePart = componentImagePin.getAttribute("attr-spec")
                var pinImagePart_type = componentImagePin.getAttribute("attr-binding-type")

                if ((pinImagePart === pinPart) && (pinImagePart_type === pinPart_type)) {
                    if (componentImagePin.classList.contains("selected")) {
                        componentImagePin.classList.remove("selected")
                    } else {
                        componentImagePin.classList.add("selected")
                    } 
                }
            })

            componentPartImages.forEach(function(partImage){
                
                var partImageName = partImage.getAttribute("attr-spec")
                var partImageType = partImage.getAttribute("attr-binding-type")

                if ((partImageName === pinPart) && (partImageType === pinPart_type)) {
                    if (partImage.classList.contains("selected")) {
                        partImage.classList.remove("selected")
                    } else {
                        partImage.classList.add("selected")
                    } 
                }
            })

            checkSelectionParts()

        }, false )
    })

    // PIN IMAGES
    componentPartsImagePins.forEach(function(componentImagePin){
        componentImagePin.addEventListener("click", function() {

            var pinPart = this.getAttribute("attr-spec")
            var pinPart_type = this.getAttribute("attr-binding-type")

            if (this.classList.contains("selected")) {
                this.classList.remove("selected")
            } else {
                this.classList.add("selected")
            } 

            // createRequestPartList()

            componentListPins.forEach(function(componentPin){
                
                var pinImagePart = componentPin.getAttribute("attr-spec")
                var pinImagePart_type = componentPin.getAttribute("attr-binding-type")

                if ((pinImagePart === pinPart) && (pinImagePart_type === pinPart_type)) {
                    if (componentPin.classList.contains("selected")) {
                        componentPin.classList.remove("selected")
                    } else {
                        componentPin.classList.add("selected")
                    } 
                }
            })

            componentPartImages.forEach(function(partImage){
                
                var partImageName = partImage.getAttribute("attr-spec")
                var partImageType = partImage.getAttribute("attr-binding-type")

                if ((partImageName === pinPart) && (partImageType === pinPart_type)) {
                    if (partImage.classList.contains("selected")) {
                        partImage.classList.remove("selected")
                    } else {
                        partImage.classList.add("selected")
                    } 
                }
            })

            checkSelectionParts()

        }, false )
    })

    // INVOLVED PARTS - END


    // PURCHASED YEAR - START
    yearPurchaseOption.forEach(function(yearPurchase){
        yearPurchase.addEventListener("click", function() {
            unlock_next()
            if(!this.classList.contains("select-style__single--select")) {
                yearPurchaseSelect.insertAdjacentElement('afterbegin', this);
                if (yearPurchaseSelect.querySelector(".select-style__single--select")) {
                    yearPurchaseSelect.querySelector(".select-style__single--select").classList.add("hide")
                }
                yearPurchaseSelect.insertAdjacentElement('afterbegin', this);
                // yearPurchaseSelect.classList.remove("open")
                // yearPurchaseSelect.querySelector(".fa-chevron-down").classList.remove("open")
                
            }

            var purchased = parseInt(yearPurchase.getAttribute("attr-purchased"))
             
            if (sessionStorage.getItem("requestType") == "Part Request") {
                check_navigation("pre","after","show","show","3","covered-1")
            } else {
                if (purchased>=coveredYear) {
                    // console.log("covered")
                    check_navigation("pre","after","show","show","3","covered-1")
                } else {
                    // console.log("not covered")  
                    if ( 
                        (sessionStorage.getItem("involvedParts").includes("Baseplate"))  
                        ||
                        (
                            (sessionStorage.getItem("involvedParts").includes("Heelcup")) 
                            && 
                            !(sessionStorage.getItem("involvedParts").includes("Heelcup Hardware"))
                        )  
                    ) {
                        // console.log("...but covered")  
                        check_navigation("pre","after","show","show","3","covered-1")
                    } else {
                        // console.log("go to part request")
                        check_navigation("pre","after","show","show","3","part-request")
                    }
                }
            }
            if (purchased != 0) {
                sessionStorage.setItem("purchasedYear", purchased)
                recapYear.innerHTML = purchased
            } else {
                sessionStorage.setItem("purchasedYear", "don't know")
                recapYear.innerHTML = "don't know"
            }
        })
    })
    // PURCHASED YEAR - END


    // FORM STEPS - START

    stepFormModels.forEach(function(stepFormModel){
        stepFormModel.addEventListener("click", function() {
            if(!this.classList.contains("select-style__single--select")) {
                stepSelectFormModels.insertAdjacentElement('afterbegin', this);
                // stepSelectFormModels.classList.remove("open")
                // stepSelectFormModels.querySelector(".fa-chevron-down").classList.remove("open")
                if (stepSelectFormModels.querySelector(".select-style__single--select")) {
                    stepSelectFormModels.querySelector(".select-style__single--select").remove()
                }
                var attr_model = stepFormModel.getAttribute("attr-model")
                // console.log(attr_model)
                recapModel.innerHTML = attr_model
            }
            checkDataCompileStep1()
        })
    })
    stepFormDirections.forEach(function(stepFormDirection){
        stepFormDirection.addEventListener("click", function() {
            if(!this.classList.contains("select-style__single--select")) {
                stepSelectFormDirections.insertAdjacentElement('afterbegin', this);
                // stepSelectFormDirections.classList.remove("open")
                // stepSelectFormDirections.querySelector(".fa-chevron-down").classList.remove("open")
                if (stepSelectFormDirections.querySelector(".select-style__single--select")) {
                    stepSelectFormDirections.querySelector(".select-style__single--select").remove()
                }
                var attr_direction = stepFormDirection.getAttribute("attr-direction")
                // console.log(attr_direction)
                recapDirection.innerHTML = attr_direction
            }
            checkDataCompileStep1()
        })
    })
    stepFormSizes.forEach(function(stepFormSize){
        stepFormSize.addEventListener("click", function() {
            if(!this.classList.contains("select-style__single--select")) {
                stepSelectFormSizes.insertAdjacentElement('afterbegin', this);
                // stepSelectFormSizes.classList.remove("open")
                // stepSelectFormSizes.querySelector(".fa-chevron-down").classList.remove("open")
                if (stepSelectFormSizes.querySelector(".select-style__single--select")) {
                    stepSelectFormSizes.querySelector(".select-style__single--select").remove()
                }
                var attr_size = stepFormSize.getAttribute("attr-size")
                // console.log(attr_size)
                recapSize.innerHTML = attr_size
            }
            checkDataCompileStep1()
        })
    })
    stepFormMessage.onkeyup = function(){
        recapMessage.innerHTML = stepFormMessage.value;
    }

    stepFormContacts_imageB.addEventListener('change', function () {
        checkDataCompileStep1()
    }, false);
    stepFormContacts_imageP.addEventListener('change', function () {
        checkDataCompileStep1()
    }, false);

    // stepFormCountries.forEach(function(stepFormCountry){
    //     stepFormCountry.addEventListener("click", function() {
    //         if(!this.classList.contains("select-style__single--select")) {
    //             stepSelectFormCountries.insertAdjacentElement('afterbegin', this);
    //             stepSelectFormCountries.classList.remove("open")
    //             if (stepSelectFormCountries.querySelector(".select-style__single--select")) {
    //                 stepSelectFormCountries.querySelector(".select-style__single--select").remove()
    //             }
    //             var attr_filter = stepFormCountry.getAttribute("attr-filter")
    //             // console.log(attr_filter)
    //             recapShipCountry.innerHTML = attr_filter
    //         }
    //         checkDataCompileStep2()
    //     })
    // })
    stepFormContacts_firstname.onkeyup = function(){
        recapInfosFirstName.innerHTML = stepFormContacts_firstname.value;
        checkDataCompileStep2()
    }
    stepFormContacts_lastname.onkeyup = function(){
        recapInfosLastName.innerHTML = stepFormContacts_lastname.value;
        checkDataCompileStep2()
    }
    stepFormContacts_email.onkeyup = function(){
        recapInfosEmail.innerHTML = stepFormContacts_email.value;
        checkDataCompileStep2()
    }
    stepFormContacts_phone.onkeyup = function(){
        recapInfosPhone.innerHTML = stepFormContacts_phone.value;
        checkDataCompileStep2()
    }
    stepFormShips_address1.onkeyup = function(){
        recapShipAddr1.innerHTML = stepFormShips_address1.value;
        checkDataCompileStep2()
    }
    stepFormShips_address2.onkeyup = function(){
        recapShipAddr2.innerHTML = stepFormShips_address2.value;
    }
    stepFormShips_city.onkeyup = function(){
        recapShipCity.innerHTML = stepFormShips_city.value;
        checkDataCompileStep2()
    }
    stepFormShips_state.onkeyup = function(){
        recapShipState.innerHTML = stepFormShips_state.value;
        checkDataCompileStep2()
    }
    stepFormShips_zip.onkeyup = function(){
        recapShipZip.innerHTML = stepFormShips_zip.value;
        checkDataCompileStep2()
    }
    stepFormShips_country.onkeyup = function(){
        recapShipCountry.innerHTML = stepFormShips_country.value;
        checkDataCompileStep2()
    }
    claimSubmitPrivacy.addEventListener("change", function(){
        if (this.checked) {
            claimSubmitBtn.classList.remove("disabled")
        } else {
            claimSubmitBtn.classList.add("disabled")
        }
    })

    claimSubmitBtn.addEventListener("click", function(){

        if (!claimSubmitBtn.classList.contains("disabled")) {
            claimSubmitBtn.classList.add("hide")
            claimSubmit.querySelector(".loader").classList.remove("hide")
        }
        
        /*
            globo form panel id
            NA: 96720
            EU: 93118
            AUS: 81463
            NZ: ???
        */

        let waranty_form_panel = document.querySelector('.globo-formbuilder')
        let waranty_form_panel__id = waranty_form_panel.getAttribute("data-id")

        var form_warranty = document.querySelector('.g-container')

        var info__firstname = document.getElementById(waranty_form_panel__id+'-text')
        var info__lastname = document.getElementById(waranty_form_panel__id+'-text-2')
        var info__email = document.getElementById(waranty_form_panel__id+'-text-3')
        var info__phone = document.getElementById(waranty_form_panel__id+'-text-4')
        var ship__addr1 = document.getElementById(waranty_form_panel__id+'-text-5')
        var ship__addr2 = document.getElementById(waranty_form_panel__id+'-text-6')
        var ship__city = document.getElementById(waranty_form_panel__id+'-text-7')
        var ship__state = document.getElementById(waranty_form_panel__id+'-text-8')
        var ship__zip = document.getElementById(waranty_form_panel__id+'-text-9')
        var ship__country = document.getElementById(waranty_form_panel__id+'-text-10')
        var info__message = document.getElementById(waranty_form_panel__id+'-text-11')
        var info__model = document.getElementById(waranty_form_panel__id+'-text-12')
        var info__direction = document.getElementById(waranty_form_panel__id+'-text-13')
        var info__size = document.getElementById(waranty_form_panel__id+'-text-14')
        var info__year = document.getElementById(waranty_form_panel__id+'-text-15')
        var info__type = document.getElementById(waranty_form_panel__id+'-text-16')
        var info__parts = document.getElementById(waranty_form_panel__id+'-text-17')
        var image__b = document.getElementById(waranty_form_panel__id+'-file')
        var image__p = document.getElementById(waranty_form_panel__id+'-file-2')

        info__firstname.value = recapInfosFirstName.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__lastname.value = recapInfosLastName.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__email.value = recapInfosEmail.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__phone.value = recapInfosPhone.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        ship__addr1.value = recapShipAddr1.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        ship__addr2.value = recapShipAddr2.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        ship__city.value = recapShipCity.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        ship__state.value = recapShipState.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        ship__zip.value = recapShipZip.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        ship__country.value = recapShipCountry.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__message.value = recapMessage.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__model.value = recapModel.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__direction.value = recapDirection.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__size.value = recapSize.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__year.value = recapYear.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__type.value = sessionStorage.getItem("requestType")
        info__parts.value = sessionStorage.getItem("involvedParts")
        image__b.files = infoImage__b.files
        image__p.files = infoImage__p.files
        
        form_warranty.querySelector(".submit").click(); 


    })
    

    // FORM STEPS - END


    // NAVIGATION BUTTONS - START
    claimPre.addEventListener("click", function(){
        var goToStep = this.getAttribute("attr_gotostep")
        claimSteps.forEach(function(claimStep){
            if (claimStep.getAttribute("attr_step") == goToStep) {
                claimStep.classList.add("active")
            } else {
                claimStep.classList.remove("active")
            }
        })
        check_step()
        scrollTop()
    })
    claimAfter.addEventListener("click", function(){
        if (!this.classList.contains("inactive")) {
            var goToStep = this.getAttribute("attr_gotostep")
            claimSteps.forEach(function(claimStep){
                if (claimStep.getAttribute("attr_step") == goToStep) {
                    claimStep.classList.add("active")
                } else {
                    claimStep.classList.remove("active")
                }        
            })
            check_step()
            scrollTop()
        } else {
            errorAfter.classList.remove("hidden")
            setTimeout(function(){
                errorAfter.classList.add("hidden")
            }, 2000)
        }
    })
    // NAVIGATION BUTTONS - END


    function redirect_country(region_selected) {
        if (region_selected == "EU") {
            window.location.replace("https://eu.unionbindingcompany.com/pages/new-warranty")
        } else if (region_selected == "NA") {
            window.location.replace("https://unionbindingcompany.com/pages/new-warranty")
        } else if (region_selected == "JP") {
            window.location.replace("https://jp.unionbindingcompany.com/pages/warranty")
        }
        // else if (region_selected == "AUS") {
        //     window.location.replace("https://aus.unionbindingcompany.com/pages/new-warranty")
        // } else if (region_selected == "NZL") {
        //     window.location.replace("https://nz.unionbindingcompany.com/pages/new-warranty")
        // } 
    }

})(document);
  